module.exports = __webpack_public_path__ + "static/factors-affecting-price-shipping-da04d95d07c9cb49fc530c382c5b1173.png";